import { Box } from '@mui/material'
import { AnimatePresence, motion, MotionStyle } from 'framer-motion'
import { ReactNode } from 'react'
import TiaIcon from '../../assets/tia-icon-without-ball.svg'

const AnimatedLogo = () => {
    const ballStyle: MotionStyle = {
        width: 20,
        height: 20,
        borderRadius: '100%',
        backgroundColor: '#EF308D',
        position: 'absolute',
        left: 44
    }

    return (
        <Box
            sx={{
                width: '128px',
                height: '68px',
                position: 'relative'
            }}
        >
            <motion.div
                animate={{
                    y: [-6, -14, -16]
                }}
                transition={{
                    duration: 0.4,
                    yoyo: Infinity,
                    ease: 'easeOut'
                }}
                style={ballStyle}
            />
            <img src={TiaIcon} width="128px" height="68px" />
        </Box>
    )
}

interface LoadingScreenProps {
    isLoading: boolean
    children?: ReactNode
}

export const LoadingScreen = ({ isLoading, children }: LoadingScreenProps) => {
    return (
        <>
            <AnimatePresence>
                {isLoading && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{
                            opacity: 1
                        }}
                        exit={{
                            opacity: 0
                        }}
                        transition={{
                            duration: 0.4
                        }}
                        style={{
                            position: 'absolute',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100vw',
                            height: '100vh'
                        }}
                    >
                        <AnimatedLogo />
                    </motion.div>
                )}
            </AnimatePresence>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{
                    opacity: isLoading ? 0 : 1
                }}
                transition={{
                    duration: 1
                }}
            >
                {!isLoading && children}
            </motion.div>
        </>
    )
}

export default LoadingScreen
